import { render, staticRenderFns } from "./SuperSyndicateReports.vue?vue&type=template&id=1ac1e8ea&scoped=true&"
import script from "./SuperSyndicateReports.vue?vue&type=script&lang=js&"
export * from "./SuperSyndicateReports.vue?vue&type=script&lang=js&"
import style0 from "./Styles/SuperSyndicate.css?vue&type=style&index=0&id=1ac1e8ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac1e8ea",
  null
  
)

export default component.exports